var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20201107 at Wed Sep 25 18:21:43 2024\n By \nCopyright 2023 The Funnel Project Authors (https://github.com/Dicotype/Funnel)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "FunnelSans-Light",
    horizAdvX: 690
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Funnel Sans Light",
    fontWeight: 300,
    fontStretch: "normal",
    unitsPerEm: 1200,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 960,
    descent: -240,
    xHeight: 600,
    capHeight: 810,
    bbox: "-232 -330 1380 1128",
    underlineThickness: 60,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 720,
    d: "M108 -180v990h504v-990h-504zM186 -108h348v846h-348v-846z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 670,
    d: "M133 0v528h-115v72h116v150q0 45 24 67.5t66 22.5h150v-72h-152v-168h140v-72h-139v-528h-90zM480 0v600h90v-600h-90zM525 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 670,
    d: "M133 0v528h-115v72h116v150q0 45 24 67.5t66 22.5h150v-72h-152v-168h140v-72h-139v-528h-90zM480 0v840h90v-840h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 760,
    d: "M133 0v528h-115v72h116v150q0 45 24 67.5t66 22.5h150v-72h-152v-168h292v150q0 45 24 67.5t66 22.5h150v-72h-152v-168h140v-72h-139v-528h-90v528h-290v-528h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 720,
    d: "M108 -180v990h504v-990h-504zM186 -108h348v846h-348v-846z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 300,
    d: "M113 246l-9 293v271h92v-270l-9 -294h-74zM150 -12q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 480,
    d: "M82 510v300h76v-300h-76zM322 510v300h76v-300h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 660,
    d: "M90 0l46 237h-118v72h132l38 192h-119v72h133l46 237h78l-46 -237h166l46 237h78l-46 -237h118v-72h-132l-38 -192h119v-72h-133l-46 -237h-78l46 237h-166l-46 -237h-78zM223 305h174l40 200h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 660,
    d: "M310 -90v105q-115 9 -184 73.5t-75 162.5h96q8 -76 61 -115t139 -39q82 0 126 35t44 99q0 51 -31 83t-100 48l-114 26q-95 22 -142 72t-47 124q0 86 58 144t157 67v75h78v-77q95 -12 154.5 -71.5t69.5 -151.5h-96q-12 68 -57 105.5t-122 37.5q-70 0 -112 -33t-42 -89 q0 -47 31 -77t97 -45l119 -27q96 -22 142 -74t46 -130q0 -92 -57.5 -151.5t-160.5 -70.5v-106h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 980,
    d: "M230 378q-76 0 -123 56.5t-47 165.5t47 165.5t123 56.5q74 0 122 -56.5t48 -165.5t-48 -165.5t-122 -56.5zM230 440q43 0 69.5 39.5t26.5 120.5t-26.5 120.5t-69.5 39.5q-44 0 -70 -39.5t-26 -120.5t26 -120.5t70 -39.5zM750 -12q-76 0 -123 56.5t-47 165.5t47 165.5 t123 56.5q74 0 122 -56.5t48 -165.5t-48 -165.5t-122 -56.5zM750 50q43 0 69.5 39.5t26.5 120.5t-26.5 120.5t-69.5 39.5q-44 0 -70 -39.5t-26 -120.5t26 -120.5t70 -39.5zM228 0l446 810h78l-446 -810h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 760,
    d: "M301 0q-68 0 -122.5 28t-86.5 79t-32 120q0 66 27 109.5t67 66t78 26.5v4q-53 11 -94.5 55.5t-41.5 114.5q0 64 29 110.5t79 71.5t113 25h185v-82h-174q-62 0 -101 -34.5t-39 -99.5q0 -64 39 -99t101 -35h204v140h88v-140h116v-80h-116v-380h-319zM321 82h211v298h-212 q-75 0 -121.5 -37t-46.5 -111q0 -73 47 -111.5t122 -38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 240,
    d: "M82 510v300h76v-300h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 330,
    d: "M198 -180q-73 93 -111.5 219t-38.5 272t38.5 273.5t111.5 225.5h96q-76 -103 -117 -232t-41 -266q0 -136 41 -262t117 -230h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 330,
    d: "M36 -180q77 104 117.5 230t40.5 262q0 137 -41 266t-117 232h96q74 -98 112 -225.5t38 -273.5t-38 -272t-112 -219h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 620,
    d: "M189 345l-65 46l71 98l63 74l-94 22l-115 37l25 76l114 -37l90 -38l-8 97v120h80v-120l-8 -97l90 38l114 37l25 -76l-115 -37l-94 -22l63 -74l71 -97l-65 -47l-71 97l-50 83l-51 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 660,
    d: "M292 135v234h-226v72h226v234h76v-234h226v-72h-226v-234h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 260,
    d: "M34 -158v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 360,
    d: "M42 260v80h276v-80h-276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 260,
    d: "M130 -12q-30 0 -51 21t-21 51t21 51t51 21t51 -21t21 -51t-21 -51t-51 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 420,
    d: "M18 -12l298 834h86l-298 -834h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 660,
    d: "M330 -12q-131 0 -199 106t-68 311t68 311t199 106t199 -106t68 -311t-68 -311t-199 -106zM330 70q89 0 133 84t44 251t-44 251t-133 84q-88 0 -132.5 -84t-44.5 -251t44.5 -251t132.5 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 660,
    d: "M122 0v80h197v625l-207 -159h-4v95l223 169h78v-730h170v-80h-457z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 660,
    d: "M72 0v72l305 335q41 45 63.5 76t32 57t9.5 55q0 66 -41.5 105.5t-109.5 39.5q-73 0 -118 -45t-53 -125h-88q5 76 38 132.5t90 88t132 31.5q69 0 123.5 -28t85.5 -78.5t31 -116.5q0 -56 -27.5 -109t-87.5 -117l-267 -287v-4h398v-82h-516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 660,
    d: "M324 -12q-115 0 -184.5 58t-79.5 164h88q6 -67 52.5 -103.5t119.5 -36.5q74 0 124 43.5t50 116.5q0 72 -49 112.5t-125 40.5h-86v76h93q74 0 111.5 41.5t37.5 96.5q0 65 -44 104t-106 39q-73 0 -114 -40.5t-52 -99.5h-86q6 64 39 114t88.5 79t127.5 29q65 0 118 -25.5 t85 -73.5t32 -115q0 -64 -38 -112t-97 -69v-4q66 -16 109.5 -66.5t43.5 -130.5q0 -78 -35.5 -131t-94 -80t-128.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 660,
    d: "M420 0v200h-390v70l390 540h88v-530h122v-80h-122v-200h-88zM121 280h303v416h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 660,
    d: "M324 -12q-115 0 -184.5 58t-79.5 164h88q6 -66 51.5 -103t120.5 -37q77 0 125.5 52t48.5 134q0 83 -48.5 135t-125.5 52q-49 0 -91 -19t-67 -52h-77l50 438h405v-82h-328l-30 -255h4q27 25 64.5 37.5t80.5 12.5q75 0 131.5 -33t88 -92t31.5 -137q0 -80 -33 -141.5 t-91 -96.5t-134 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 660,
    d: "M349 -12q-136 0 -209 100t-73 287q0 140 35 240t99.5 153.5t154.5 53.5q92 0 154 -50t82 -142h-90q-16 53 -54 81.5t-92 28.5q-88 0 -142 -84.5t-59 -247.5h4q28 56 80.5 85.5t112.5 29.5q74 0 129 -33t86 -92t31 -137q0 -80 -31.5 -142t-87.5 -96.5t-130 -34.5zM345 70 q73 0 119 52t46 134q0 53 -22.5 95.5t-63 67t-93.5 24.5q-72 0 -120 -44.5t-48 -112.5q0 -62 24 -111t65.5 -77t92.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 660,
    d: "M167 0l340 726h-447v84h540v-77l-335 -733h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 660,
    d: "M330 -12q-71 0 -131 27t-96.5 79.5t-36.5 128.5q0 77 43 126.5t98 71.5v4q-47 22 -82 71t-35 110q0 69 32.5 117t87 73.5t120.5 25.5q67 0 121 -25.5t86.5 -73.5t32.5 -117q0 -61 -35 -107t-82 -68v-4q56 -22 98.5 -74.5t42.5 -129.5q0 -76 -36.5 -128.5t-96.5 -79.5 t-131 -27zM330 68q47 0 87 19.5t64.5 55.5t24.5 84q0 49 -24.5 84.5t-64.5 55t-87 19.5t-87 -19.5t-64.5 -55t-24.5 -84.5q0 -48 24.5 -84t64.5 -55.5t87 -19.5zM330 464q62 0 107 37.5t45 101.5q0 65 -45 102t-107 37t-107 -37t-45 -102q0 -64 45 -101.5t107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 660,
    d: "M310 -12q-99 0 -165.5 54t-86.5 156h90q15 -64 58 -96t104 -32q88 0 134.5 86.5t50.5 254.5h-4q-26 -52 -75.5 -82t-111.5 -30q-72 0 -126 32.5t-84 91t-30 135.5t31.5 136.5t87 93.5t126.5 34q131 0 202.5 -99.5t71.5 -282.5q0 -146 -31.5 -247t-92.5 -153t-149 -52z M325 377q71 0 116.5 43.5t45.5 110.5q0 60 -23 107.5t-62 75.5t-89 28q-71 0 -117 -51t-46 -131q0 -81 49 -132t126 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 320,
    d: "M160 48q-30 0 -51 21t-21 51t21 51t51 21t51 -21t21 -51t-21 -51t-51 -21zM160 408q-30 0 -51 21t-21 51t21 51t51 21t51 -21t21 -51t-21 -51t-51 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 320,
    d: "M64 -98v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42zM160 408q-30 0 -51 21t-21 51t21 51t51 21t51 -21t21 -51t-21 -51t-51 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 660,
    d: "M582 142l-504 216v94l504 216v-82l-430 -181l430 -181v-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 660,
    d: "M78 471v72h504v-72h-504zM78 267v72h504v-72h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 660,
    d: "M78 142v82l430 181l-430 181v82l504 -216v-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 540,
    d: "M189 246q0 75 18.5 117t67.5 80l49 39q42 34 61 65.5t19 68.5q0 59 -39 92.5t-100 33.5q-58 0 -93 -28.5t-46 -83.5h-90q12 88 73.5 140t158.5 52q98 0 161 -54.5t63 -149.5q0 -54 -25 -99t-78 -89l-65 -53q-33 -27 -45 -53t-14 -78h-76zM225 -12q-28 0 -48.5 20.5 t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1080,
    d: "M548 -120q-144 0 -251 58.5t-166 162t-59 239.5q0 107 36 195t102 152.5t156 99.5t198 35q100 0 183.5 -31.5t144.5 -87.5t94.5 -131.5t33.5 -164.5q0 -90 -33 -161t-88 -112t-122 -41q-47 0 -74 22.5t-34 69.5h-4q-42 -92 -148 -92q-62 0 -107.5 32t-70.5 88.5 t-25 131.5t25 132t70.5 88.5t107.5 31.5q106 0 148 -92h4v80h76v-432q59 0 103.5 33t69 89t24.5 126q0 97 -48 174.5t-132.5 123t-196.5 45.5q-122 0 -216 -51t-146.5 -141.5t-52.5 -211.5q0 -114 48 -200t137.5 -134t212.5 -48h270v-78h-270zM536 159q59 0 96 39t37 107v80 q0 68 -37 107t-96 39q-69 0 -107.5 -51t-38.5 -135t38.5 -135t107.5 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 770,
    d: "M114 0v810h339q64 0 113.5 -25t78.5 -71.5t29 -110.5q0 -70 -41.5 -114.5t-94.5 -55.5v-4q39 -4 78.5 -26.5t66.5 -66t27 -109.5q0 -69 -32 -120t-86.5 -79t-122.5 -28h-355zM206 82h243q75 0 122 38.5t47 111.5q0 74 -46.5 111t-121.5 37h-244v-298zM206 460h236 q62 0 101 35t39 99q0 65 -39 99.5t-101 34.5h-236v-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 790,
    d: "M434 -12q-109 0 -192 52.5t-129.5 146.5t-46.5 218t46.5 218t129.5 146.5t192 52.5q84 0 150.5 -30.5t109.5 -87t56 -134.5h-96q-13 77 -71.5 122.5t-148.5 45.5q-83 0 -145 -41.5t-95.5 -116t-33.5 -175.5q0 -100 33.5 -175t95.5 -116.5t145 -41.5q90 0 148.5 46 t71.5 122h96q-13 -77 -56 -134t-109.5 -87.5t-150.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 810,
    d: "M114 0v810h243q122 0 211.5 -49t138.5 -140t49 -216q0 -124 -49 -215t-138.5 -140.5t-211.5 -49.5h-243zM206 82h151q99 0 167 40.5t103 113t35 169.5q0 146 -78 234.5t-227 88.5h-151v-646z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 640,
    d: "M206 0h-92v810h496v-82h-404v-279h383v-82h-383v-367z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 840,
    d: "M425 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48.5 218t133.5 146.5t194 52.5q84 0 150 -30.5t108.5 -87t55.5 -134.5h-96q-13 77 -70.5 122.5t-147.5 45.5q-84 0 -147.5 -41.5t-99 -116.5t-35.5 -175q0 -97 35 -173.5t97.5 -120.5t142.5 -44q67 0 119 26t82 71 t30 100v58h-244v80h244q43 0 66.5 -23.5t23.5 -66.5v-312h-88v126h-4q-22 -59 -86 -98.5t-153 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 850,
    d: "M114 0v810h92v-349h438v349h92v-810h-92v379h-438v-379h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 440,
    d: "M30 0v82h204v728h92v-720q0 -45 -24 -67.5t-66 -22.5h-206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 740,
    d: "M114 0v810h92v-404h4l380 404h114l-341 -352l353 -458h-114l-306 396l-90 -79v-317h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 640,
    d: "M114 0v810h92v-728h404v-82h-496z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1030,
    d: "M114 0v810h138l261 -680h4l262 680h137v-810h-92v709h-4l-270 -709h-76l-270 710h-4v-710h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 880,
    d: "M766 0h-106l-456 681h-4v-681h-86v810h106l456 -681h4v681h86v-810z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 730,
    d: "M114 0v810h313q121 0 191 -66t70 -180q0 -113 -70.5 -179.5t-190.5 -66.5h-221v-318h-92zM206 398h217q80 0 126.5 45t46.5 121q0 77 -46.5 121.5t-126.5 44.5h-217v-332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 870,
    d: "M481 -180q-42 0 -66 22.5t-24 67.5v80q-95 11 -168.5 64.5t-115 143t-41.5 207.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -118 -41.5 -207.5t-114 -142.5t-167.5 -64v-87h223v-84h-223zM435 70q84 0 146 41.5t95.5 117 t33.5 176.5q0 102 -33.5 177.5t-95.5 116.5t-146 41t-145.5 -41t-95.5 -116.5t-34 -177.5q0 -101 34 -176.5t95.5 -117t145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 790,
    d: "M114 0v810h335q73 0 128 -26t86 -75.5t31 -120.5q0 -52 -21.5 -95.5t-68.5 -72.5v-5q43 0 66.5 -23.5t23.5 -66.5v-325h-92v340h-396v-340h-92zM206 418h233q73 0 118 40.5t45 115.5t-45 115.5t-118 40.5h-233v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 720,
    d: "M370 -12q-93 0 -162.5 32t-109.5 88.5t-45 131.5h98q9 -82 67.5 -125t154.5 -43q92 0 141.5 38.5t49.5 107.5q0 56 -35.5 92t-110.5 52l-125 27q-98 21 -151 74t-53 135q0 65 32.5 115.5t92.5 79.5t141 29q84 0 146.5 -30t100.5 -84t46 -126h-98q-13 77 -65 116.5 t-135 39.5q-77 0 -124 -35.5t-47 -97.5q0 -49 33.5 -83t109.5 -51l130 -29q101 -22 151.5 -76.5t50.5 -140.5q0 -107 -75 -172t-209 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    d: "M391 0h-92v728h-275v82h642v-82h-275v-728z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 750,
    d: "M317 0l-305 810h103l261 -714h4l259 714h99l-305 -810h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1080,
    d: "M245 0l-209 810h98l163 -696h4l187 696h96l196 -696h4l162 696h98l-209 -810h-102l-196 699h-4l-186 -699h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 710,
    d: "M20 0l277 422l-257 388h106l210 -324h4l210 324h100l-257 -386l277 -424h-108l-226 357h-4l-230 -357h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    d: "M299 0v306l-287 504h106l228 -407h4l228 407h100l-287 -502v-308h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 680,
    d: "M54 0v72l450 656h-432v82h542v-72l-450 -656h462v-82h-572z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 370,
    d: "M90 -180v990h250v-72h-164v-846h164v-72h-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 420,
    d: "M402 -12h-86l-298 834h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 370,
    d: "M30 -179v72h164v845h-164v72h250v-989h-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 660,
    d: "M67 153l216 504h94l216 -504h-82l-181 430l-181 -430h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 600,
    d: "M606 -156h-612v72h612v-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 600,
    d: "M345 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M379 -12q-137 0 -189 114h-4v-102h-90v840h90v-342h4q52 114 189 114q75 0 131 -39t87 -109t31 -164q0 -93 -31 -163.5t-87 -109.5t-131 -39zM356 68q83 0 132.5 63.5t49.5 168.5t-49.5 168.5t-132.5 63.5q-81 0 -125.5 -51t-44.5 -132v-98q0 -81 44.5 -132t125.5 -51z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 620,
    d: "M338 -12q-79 0 -141.5 38.5t-98.5 108.5t-36 165q0 96 36 166t98.5 108t141.5 38q60 0 111 -22.5t87 -68t51 -115.5h-94q-16 65 -57.5 94.5t-97.5 29.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63q59 0 101.5 32t58.5 102h92q-14 -72 -50.5 -120t-88 -72 t-113.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M311 -12q-75 0 -131 39t-87 109.5t-31 163.5q0 94 31 164t87 109t131 39q137 0 189 -114h4v342h90v-840h-90v102h-4q-52 -114 -189 -114zM334 68q81 0 125.5 51t44.5 132v98q0 81 -44.5 132t-125.5 51q-82 0 -132 -63.5t-50 -168.5t50 -168.5t132 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 380,
    d: "M133 0v528h-115v72h116v150q0 45 24 67.5t66 22.5h150v-72h-152v-168h140v-72h-139v-528h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M323 -252q-108 0 -180 52.5t-84 139.5h96q11 -52 55 -81t111 -29q86 0 134.5 48.5t48.5 133.5v102h-4q-22 -54 -70 -84t-113 -30q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q65 0 113 -30t70 -83h4v101h90v-595q0 -118 -73.5 -187.5 t-197.5 -69.5zM338 82q75 0 120.5 49t45.5 129v92q0 80 -45.5 129t-120.5 49q-85 0 -135.5 -61t-50.5 -163t50.5 -163t135.5 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M96 0v840h90v-330h4q26 47 74 74.5t112 27.5q66 0 116 -30.5t78 -85t28 -126.5v-370h-90v359q0 82 -42.5 127.5t-118.5 45.5t-118.5 -45.5t-42.5 -127.5v-359h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM145 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 283,
    d: "M-18 -240v72h121v768h90v-750q0 -45 -24 -67.5t-66 -22.5h-121zM148 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 620,
    d: "M96 0v840h90v-528h4l279 288h109l-251 -254l275 -346h-111l-226 290l-79 -70v-220h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 290,
    d: "M100 0v840h90v-840h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1040,
    d: "M96 0v600h90v-100h4q22 54 67 82.5t107 28.5t110 -30.5t73 -88.5h3q28 58 76.5 88.5t111.5 30.5t110.5 -29t73.5 -82t26 -125v-375h-90v363q0 79 -38.5 122.5t-106.5 43.5q-67 0 -106.5 -43.5t-39.5 -122.5v-363h-90v363q0 79 -38.5 122.5t-106.5 43.5 q-67 0 -106.5 -43.5t-39.5 -122.5v-363h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M96 0v600h90v-100h4q26 54 74 82.5t112 28.5q66 0 116 -31t78 -85.5t28 -125.5v-369h-90v355q0 81 -42.5 127.5t-118.5 46.5t-118.5 -46.5t-42.5 -127.5v-355h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M96 -240v840h90v-102h4q52 114 189 114q75 0 131 -39t87 -109t31 -164q0 -93 -31 -163.5t-87 -109.5t-131 -39q-137 0 -189 114h-4v-342h-90zM356 68q83 0 132.5 63.5t49.5 168.5t-49.5 168.5t-132.5 63.5q-81 0 -125.5 -51t-44.5 -132v-98q0 -81 44.5 -131t125.5 -52z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M504 -240v342h-4q-52 -114 -189 -114q-75 0 -131 39t-87 109.5t-31 163.5q0 94 31 164t87 109t131 39q137 0 189 -114h4v102h90v-840h-90zM334 68q81 2 125.5 52t44.5 131v98q0 81 -44.5 132t-125.5 51q-82 0 -132 -63.5t-50 -168.5t50 -168.5t132 -63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 460,
    d: "M108 0v600h85v-127h4q20 59 67.5 95t116.5 36h43v-80h-48q-85 0 -131.5 -56t-46.5 -152v-316h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 560,
    d: "M292 -12q-106 0 -172 52.5t-72 139.5h90q6 -55 46.5 -84.5t110.5 -29.5q65 0 99 25.5t34 72.5q0 73 -101 95l-95 20q-160 34 -160 158q0 78 58 126.5t152 48.5q92 0 153.5 -49.5t70.5 -132.5h-88q-10 50 -46.5 77t-92.5 27t-89.5 -24.5t-33.5 -66.5q0 -34 24 -54.5 t76 -31.5l95 -20q80 -17 120.5 -58.5t40.5 -107.5q0 -84 -59 -133.5t-161 -49.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 400,
    d: "M209 0q-40 0 -63 21.5t-23 64.5v442h-105v72h106v180h88v-180h150v-72h-149v-456h163v-72h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 580,
    d: "M238 0l-232 600h93l192 -510h4l190 510h89l-232 -600h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 900,
    d: "M189 0l-171 600h92l133 -492h4l156 492h96l156 -492h4l133 492h90l-171 -600h-102l-157 498h-4l-157 -498h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 580,
    d: "M18 0l217 307l-207 293h104l159 -231l159 231h102l-207 -293l217 -307h-104l-169 245l-169 -245h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 580,
    d: "M60 -240v72h138l60 164l-252 604h93l202 -490h4l179 490h90l-227 -600l-57 -150q-16 -42 -32 -66t-58 -24h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 560,
    d: "M54 0v66l344 460h-326v74h428v-66l-344 -460h350v-74h-452z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 420,
    d: "M390 -180q-78 0 -127.5 18.5t-73 57.5t-23.5 99v174q0 59 -31 83.5t-105 24.5v76q75 1 105.5 25.5t30.5 82.5v174q0 60 24 98.5t73.5 57.5t126.5 19v-75q-75 0 -104.5 -24t-29.5 -84v-171q0 -63 -28 -96t-90 -43v-4q62 -9 90 -41t28 -97v-174q0 -59 29 -82.5t105 -23.5 v-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 600,
    d: "M261 -180v1020h78v-1020h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 420,
    d: "M30 -180v75q75 0 104.5 24t29.5 84v171q0 63 28.5 96t89.5 43v4q-62 9 -90 41.5t-28 96.5v174q0 59 -28.5 82.5t-105.5 23.5v75q79 0 128 -18.5t72.5 -57t23.5 -99.5v-174q0 -59 31 -83.5t105 -24.5v-76q-75 -1 -105.5 -25t-30.5 -83v-174q0 -59 -24 -98t-73.5 -58 t-126.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 660,
    d: "M82 333h-4v85q26 31 58.5 46t69.5 15q48 0 88 -18t78.5 -36t80.5 -18q36 0 67.5 17.5t57.5 52.5h4v-85q-26 -31 -58 -46t-70 -15q-48 0 -88 18t-78.5 36t-80.5 18q-36 0 -67.5 -17.5t-57.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 300,
    d: "M187 354l9 -293v-271h-92v270l9 294h74zM150 612q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 660,
    d: "M321 -12v107q-69 9 -123 49.5t-85 107t-31 153.5q0 88 31 154.5t85 106.5t123 49v95h78v-96q76 -10 132 -60.5t76 -142.5h-94q-16 65 -57.5 94.5t-97.5 29.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63q59 0 101.5 32t58.5 102h92q-19 -96 -76 -149t-135 -64 v-108h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 660,
    d: "M70 0v76q46 14 71.5 56.5t17.5 125.5l-9 101h-132v72h126l-11 129q-7 83 21.5 141.5t83.5 89.5t125 31q92 0 152 -51.5t72 -140.5h-88q-10 54 -45 83t-91 29q-69 0 -111 -47.5t-33 -144.5l11 -119h228v-72h-222l9 -100q7 -76 -13.5 -114t-62.5 -59v-4h431v-82h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 660,
    d: "M139 163l-51 51l94 94q-13 21 -21 45.5t-8 51.5q0 52 28 96l-93 92l54 54l92 -93q44 28 96 28q27 0 51.5 -7.5t45.5 -21.5l94 94l51 -51l-94 -94q14 -21 21.5 -45.5t7.5 -51.5q0 -52 -28 -96l93 -92l-54 -54l-92 93q-44 -28 -96 -28q-27 0 -51.5 8t-45.5 21zM330 298 q44 0 75.5 31.5t31.5 75.5t-31.5 75.5t-75.5 31.5t-75.5 -31.5t-31.5 -75.5t31.5 -75.5t75.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 660,
    d: "M286 0v169h-190v68h190v96h-190v68h155l-221 409h104l197 -377h4l197 377h98l-222 -409h156v-68h-190v-96h190v-68h-190v-169h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 600,
    d: "M261 450v390h78v-390h-78zM261 -180v390h78v-390h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 660,
    d: "M334 -192q-121 0 -197 60.5t-83 161.5h94q8 -67 57 -104t132 -37q78 0 120 32t42 90q0 93 -123 120l-130 28q-88 19 -135 64t-47 110q0 101 107 143v4q-44 24 -65.5 59t-21.5 84q0 59 30 104t84 70t124 25q107 0 177.5 -57t80.5 -154h-93q-11 63 -54.5 96.5t-114.5 33.5 q-67 0 -107 -30.5t-40 -81.5q0 -85 121 -110l133 -28q88 -18 134.5 -64.5t46.5 -116.5q0 -48 -24 -82t-74 -59v-4q78 -41 78 -147q0 -97 -68 -153.5t-184 -56.5zM453 193q66 36 66 99q0 99 -123 123l-170 37q-35 -13 -55 -40t-20 -63q0 -86 121 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 600,
    d: "M417 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM183 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1080,
    d: "M540 -132q-99 0 -185 37t-152 103t-103 152t-37 185t37 185t103 152t152 103t185 37t185 -37t152 -103t103 -152t37 -185t-37 -185t-103 -152t-152 -103t-185 -37zM540 -54q83 0 155 31t127 86t86 127.5t31 154.5q0 83 -31 155t-86 127t-127 86t-155 31q-82 0 -154.5 -31 t-127.5 -86t-86 -127t-31 -155q0 -82 31 -154.5t86 -127.5t127.5 -86t154.5 -31zM540 93q-64 0 -115 31t-80.5 88t-29.5 133q0 77 29.5 133.5t80.5 87.5t115 31q73 0 128.5 -41t74.5 -125h-80q-13 53 -46 76.5t-77 23.5q-68 0 -108.5 -50.5t-40.5 -135.5q0 -84 40.5 -135 t108.5 -51q47 0 80.5 26t46.5 82h78q-17 -87 -74 -130.5t-131 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 380,
    d: "M150 384q-51 0 -82.5 28.5t-31.5 74.5q0 48 32.5 74.5t90.5 26.5h93v16q0 33 -18.5 51.5t-51.5 18.5q-26 0 -45 -12t-25 -37h-71q9 51 47 79t95 28q63 0 99 -33.5t36 -94.5v-214h-65v54h-2q-13 -28 -40 -44t-61 -16zM164 442q38 0 63 24t25 60v10h-89q-63 0 -63 -46 q0 -22 17 -35t47 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 590,
    d: "M210 61l-168 239l168 239h88l-168 -239l168 -239h-88zM460 61l-168 239l168 239h88l-168 -239l168 -239h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 660,
    d: "M486 193v174h-408v76h484v-250h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1080,
    d: "M540 -132q-99 0 -185 37t-152 103t-103 152t-37 185t37 185t103 152t152 103t185 37t185 -37t152 -103t103 -152t37 -185t-37 -185t-103 -152t-152 -103t-185 -37zM540 -54q83 0 155 31t127 86t86 127.5t31 154.5q0 83 -31 155t-86 127t-127 86t-155 31q-82 0 -154.5 -31 t-127.5 -86t-86 -127t-31 -155q0 -82 31 -154.5t86 -127.5t127.5 -86t154.5 -31zM356 105v480h223q70 0 113.5 -37t43.5 -105q0 -37 -15.5 -64.5t-45.5 -43.5v-4q29 0 45 -16.5t16 -47.5v-162h-76v173h-228v-173h-76zM432 344h137q40 0 65.5 22.5t25.5 63.5t-25.5 64 t-65.5 23h-137v-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 600,
    d: "M116 717v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 480,
    d: "M240 468q-49 0 -89 24t-64 64t-24 89t24 89t64 64t89 24t89 -24t64 -64t24 -89t-24 -89t-64 -64t-89 -24zM240 538q44 0 75.5 31.5t31.5 75.5t-31.5 75.5t-75.5 31.5t-75.5 -31.5t-31.5 -75.5t31.5 -75.5t75.5 -31.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 660,
    d: "M292 285v174h-226v72h226v174h76v-174h226v-72h-226v-174h-76zM78 99v72h504v-72h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 460,
    d: "M76 600v51l173 165q32 30 42.5 50t10.5 41q0 29 -21 47t-53 18q-34 0 -57 -20t-28 -58h-67q4 62 45 100t108 38q62 0 102 -34t40 -89q0 -35 -16.5 -64.5t-51.5 -62.5l-127 -118v-2h202v-62h-302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 460,
    d: "M226 588q-70 0 -111 33t-46 93h70q3 -31 26 -47.5t59 -16.5q37 0 61.5 19t24.5 53q0 31 -24 48.5t-62 17.5h-47v60h50q35 0 54 17.5t19 42.5q0 29 -21.5 46.5t-52.5 17.5q-34 0 -55.5 -17t-26.5 -49h-67q4 56 45.5 91t105.5 35q59 0 99.5 -31t40.5 -84q0 -30 -19 -54.5 t-51 -38.5v-3q35 -10 58.5 -36t23.5 -66q0 -61 -44.5 -96t-109.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 600,
    d: "M189 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 660,
    d: "M286 -180v498q-121 0 -191.5 66.5t-70.5 179.5q0 114 70.5 180t191.5 66h80v-990h-80zM466 -180v990h80v-990h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 260,
    d: "M130 228q-30 0 -51 21t-21 51t21 51t51 21t51 -21t21 -51t-21 -51t-51 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 600,
    d: "M192 -268v66h133v29q0 41 -29.5 56.5t-74.5 20.5l65 126h60l-45 -91q41 -8 69.5 -33t28.5 -84q0 -37 -23 -63.5t-67 -26.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 460,
    d: "M232 600v340l-115 -79h-2v72l126 87h61v-420h-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 400,
    d: "M200 378q-70 0 -116 48.5t-46 128.5t46 128.5t116 48.5q71 0 116.5 -47.5t45.5 -129.5t-45.5 -129.5t-116.5 -47.5zM200 442q41 0 66.5 31t25.5 82q0 53 -25.5 83t-66.5 30q-40 0 -66 -30t-26 -83q0 -51 26 -82t66 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 590,
    d: "M42 61l168 239l-168 239h88l168 -239l-168 -239h-88zM292 61l168 239l-168 239h88l168 -239l-168 -239h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1079,
    d: "M232 390v340l-115 -79h-2v72l126 87h61v-420h-70zM790 0v96h-215v50l218 274h65v-266h63v-58h-63v-96h-68zM647 154h146v181h-2zM248 0l446 810h78l-446 -810h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1056,
    d: "M232 390v340l-115 -79h-2v72l126 87h61v-420h-70zM596 0v51l173 165q32 30 42.5 50t10.5 41q0 29 -21 47t-53 18q-34 0 -57 -20t-28 -58h-67q4 62 45 100t108 38q62 0 102 -34t40 -89q0 -35 -16.5 -64.5t-51.5 -62.5l-127 -118v-2h202v-62h-302zM218 0l446 810h78 l-446 -810h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1001,
    d: "M226 378q-70 0 -111 33t-46 93h70q3 -31 26 -47.5t59 -16.5q37 0 61.5 19t24.5 53q0 31 -24 48.5t-62 17.5h-47v60h50q35 0 54 17.5t19 42.5q0 29 -21.5 46.5t-52.5 17.5q-34 0 -55.5 -17t-26.5 -49h-67q4 56 45.5 91t105.5 35q59 0 99.5 -31t40.5 -84q0 -30 -19 -54.5 t-51 -38.5v-3q35 -10 58.5 -36t23.5 -66q0 -61 -44.5 -96t-109.5 -35zM790 0v96h-215v50l218 274h65v-266h63v-58h-63v-96h-68zM647 154h146v181h-2zM258 0l446 810h78l-446 -810h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 540,
    d: "M351 354q0 -75 -18.5 -117t-67.5 -80l-49 -39q-42 -34 -61 -65t-19 -69q0 -59 39 -92.5t100 -33.5q59 0 93.5 28.5t45.5 83.5h90q-12 -88 -73 -140t-159 -52t-161 54.5t-63 149.5q0 54 25 99.5t78 88.5l65 53q33 27 45 53t14 78h76zM315 612q29 0 49 -20t20 -49 q0 -28 -20 -48.5t-49 -20.5q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM373 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM313 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM192 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM172 888q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM493 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM259 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5 t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM376 858q-37 0 -68.5 18t-50 48.5t-18.5 68.5q0 39 18.5 69.5t50 48t68.5 17.5q38 0 69 -17.5t49.5 -48t18.5 -69.5q0 -38 -18.5 -68.5t-49.5 -48.5t-69 -18zM376 919q30 0 52 21 t22 53t-22 53t-52 21t-52 -21t-22 -53t22 -53t52 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1100,
    d: "M6 0l316 810h500l31 -82h-391l104 -268h366l30 -80h-365l115 -298h381l31 -82h-476l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 790,
    d: "M434 -12q-109 0 -192 52.5t-129.5 146.5t-46.5 218t46.5 218t129.5 146.5t192 52.5q84 0 150.5 -30.5t109.5 -87t56 -134.5h-96q-13 77 -71.5 122.5t-148.5 45.5q-83 0 -145 -41.5t-95.5 -116t-33.5 -175.5q0 -100 33.5 -175t95.5 -116.5t145 -41.5q90 0 148.5 46 t71.5 122h96q-13 -77 -56 -134t-109.5 -87.5t-150.5 -30.5zM326 -268v66h133v29q0 41 -29.5 56.5t-74.5 20.5l65 126h60l-45 -91q41 -8 69.5 -33t28.5 -84q0 -37 -23 -63.5t-67 -26.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM364 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM304 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM183 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM484 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM250 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5 t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM157 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM97 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM-24 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM277 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM43 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 840,
    d: "M144 0v383h-114v74h114v353h243q122 0 211.5 -49t138.5 -140t49 -216q0 -124 -49 -215t-138.5 -140.5t-211.5 -49.5h-243zM236 82h151q99 0 167 40.5t103 113t35 169.5q0 146 -78 234.5t-227 88.5h-151v-271h238v-74h-238v-301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 880,
    d: "M766 0h-106l-456 681h-4v-681h-86v810h106l456 -681h4v681h86v-810zM246 888q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM432 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM372 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM251 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM231 888q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM552 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM318 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5 t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 660,
    d: "M139 163l-51 51l190 190l-190 189l54 54l189 -190l190 190l51 -51l-190 -190l190 -189l-54 -54l-189 190z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 870,
    d: "M151 -49l-59 42l78 109q-49 54 -76.5 131t-27.5 172q0 128 48 221.5t131.5 144.5t189.5 51q119 0 207 -61l70 98l60 -42l-75 -104q50 -54 78.5 -132t28.5 -176q0 -127 -48 -221t-131 -145t-190 -51q-60 0 -113.5 17t-97.5 48zM224 177l367 513q-67 48 -156 48 q-84 0 -145.5 -41t-95.5 -116t-34 -176q0 -70 16.5 -127.5t47.5 -100.5zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 143 -67 232l-368 -513q66 -52 160 -52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM408 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM348 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM227 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM528 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5 zM294 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    d: "M299 0v306l-287 504h106l228 -407h4l228 407h100l-287 -502v-308h-92zM285 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 730,
    d: "M114 0v810h92v-150h221q121 0 191 -66t70 -180q0 -113 -70.5 -179.5t-190.5 -66.5h-221v-168h-92zM206 248h217q80 0 126.5 45t46.5 121q0 77 -46.5 121.5t-126.5 44.5h-217v-332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    d: "M276 -1v78h64q93 0 145.5 45.5t52.5 125.5t-52.5 125.5t-144.5 45.5h-65v78h55q79 0 120.5 37.5t41.5 104.5t-37.5 104t-108.5 37q-76 0 -118.5 -45.5t-42.5 -130.5v-604h-90v609q0 74 31 128.5t88 84.5t133 30q71 0 124 -26t83 -72.5t30 -107.5q0 -68 -38 -115.5 t-106 -61.5v-4q54 -5 96.5 -35t66.5 -78t24 -106q0 -73 -34 -128.5t-94 -86.5t-139 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM297 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM237 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM116 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM96 678q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM417 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM183 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5 t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM300 678q-33 0 -61 16t-44.5 43t-16.5 61t16.5 61t44.5 43t61 16q34 0 61.5 -16t44 -43t16.5 -61t-16.5 -61t-44 -43t-61.5 -16zM300 734q26 0 45 18t19 46t-19 46t-45 18t-45 -18t-19 -46t19 -46t45 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1030,
    d: "M723 -12q-76 0 -137 34.5t-95 96.5h-4q-65 -130 -237 -130q-90 0 -146 52.5t-56 134.5q0 87 55 136t157 49h188v17q0 74 -39 114t-111 40q-60 0 -97.5 -26.5t-48.5 -75.5h-92q13 83 78.5 132.5t162.5 49.5q75 0 127 -29.5t77 -82.5h4q36 53 90 82.5t118 29.5 q72 0 129 -34t89.5 -96.5t32.5 -147.5v-45h-434q4 -100 56 -159.5t132 -59.5q56 0 97 29.5t55 79.5h92q-20 -90 -86.5 -140.5t-156.5 -50.5zM268 67q52 0 92.5 23.5t64 64t23.5 90.5v44h-181q-67 0 -101 -29t-34 -80q0 -52 36.5 -82.5t99.5 -30.5zM539 361h342 q-7 80 -52 125.5t-113 45.5q-67 0 -115 -45.5t-62 -125.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 620,
    d: "M338 -12q-79 0 -141.5 38.5t-98.5 108.5t-36 165q0 96 36 166t98.5 108t141.5 38q60 0 111 -22.5t87 -68t51 -115.5h-94q-16 65 -57.5 94.5t-97.5 29.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63q59 0 101.5 32t58.5 102h92q-14 -72 -50.5 -120t-88 -72 t-113.5 -24zM230 -268v66h133v29q0 41 -29.5 56.5t-74.5 20.5l65 126h60l-45 -91q41 -8 69.5 -33t28.5 -84q0 -37 -23 -63.5t-67 -26.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM322 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM262 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM141 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM442 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM208 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM142 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM82 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM-39 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM226 691q-23 0 -38 17t-15 42q0 26 15 42.5t38 16.5t38 -16.5t15 -42.5q0 -25 -15 -42t-38 -17zM64 691q-23 0 -38 17t-15 42q0 26 15 42.5t38 16.5t38 -16.5t15 -42.5q0 -25 -15 -42t-38 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 680,
    d: "M342 -12q-83 0 -146 37.5t-98.5 104t-35.5 153.5q0 88 35 155.5t96.5 105.5t141.5 38q105 0 175 -80h6q-24 50 -71 101t-109 100l-164 -88l-29 54l138 74q-37 26 -77.5 49.5t-84.5 43.5v4h135q54 -24 102 -57l128 69l29 -54l-104 -56q99 -84 158 -198.5t59 -233.5 q0 -97 -35.5 -169.5t-99 -112.5t-149.5 -40zM338 66q60 0 105 29.5t70 82.5t25 123q0 95 -47.5 150t-131.5 55q-61 0 -108 -29.5t-74 -81t-27 -117.5q0 -62 24 -110t66.5 -75t97.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    d: "M96 0v600h90v-100h4q26 54 74 82.5t112 28.5q66 0 116 -31t78 -85.5t28 -125.5v-369h-90v355q0 81 -42.5 127.5t-118.5 46.5t-118.5 -46.5t-42.5 -127.5v-355h-90zM143 678q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39 q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM337 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM277 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM156 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM136 678q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM457 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM223 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 660,
    d: "M78 367v76h504v-76h-504zM330 141q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM330 531q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 680,
    d: "M138 -36l-57 39l55 76q-35 40 -54.5 96t-19.5 125q0 96 36 166t99 108t143 38q88 0 153 -44l47 65l59 -38l-53 -73q35 -40 53.5 -96t18.5 -126q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38q-87 0 -152 44zM188 146l258 356q-45 31 -106 31q-87 0 -139.5 -63t-52.5 -170 q0 -91 40 -154zM340 67q89 0 140.5 63.5t51.5 169.5q0 91 -39 152l-257 -351q46 -34 104 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM342 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM282 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM161 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM462 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5 t-41.5 -17.5zM228 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 580,
    d: "M60 -240v72h138l60 164l-252 604h93l202 -490h4l179 490h90l-227 -600l-57 -150q-16 -42 -32 -66t-58 -24h-140zM227 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    d: "M96 -240v1080h90v-342h4q52 114 189 114q75 0 131 -39t87 -109t31 -164q0 -93 -31 -163.5t-87 -109.5t-131 -39q-137 0 -189 114h-4v-342h-90zM356 68q83 0 132.5 63.5t49.5 168.5t-49.5 168.5t-132.5 63.5q-81 0 -125.5 -51t-44.5 -132v-98q0 -81 44.5 -131t125.5 -52z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 580,
    d: "M60 -240v72h138l60 164l-252 604h93l202 -490h4l179 490h90l-227 -600l-57 -150q-16 -42 -32 -66t-58 -24h-140zM407 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM173 691q-24 0 -41.5 17.5t-17.5 41.5 t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM192 927v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM116 717v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM375 890q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM299 680q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 750,
    d: "M6 0l316 810h108l314 -810h-96l-95 256h-357l-96 -256h-94zM227 340h295l-145 386h-4zM675 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 620,
    d: "M247 -11q-88 0 -143.5 50t-55.5 129q0 84 54.5 131t154.5 47h185v32q0 74 -38.5 114t-108.5 40q-58 0 -95 -26.5t-48 -75.5h-92q13 83 78 132.5t160 49.5q108 0 169 -59.5t61 -167.5v-385h-86v111h-4q-23 -56 -75 -89t-116 -33zM265 67q50 0 90 23.5t63.5 64t23.5 90.5 v29h-178q-65 0 -98.5 -27t-33.5 -75t36 -76.5t97 -28.5zM459 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 790,
    d: "M434 -12q-109 0 -192 52.5t-129.5 146.5t-46.5 218t46.5 218t129.5 146.5t192 52.5q84 0 150.5 -30.5t109.5 -87t56 -134.5h-96q-13 77 -71.5 122.5t-148.5 45.5q-83 0 -145 -41.5t-95.5 -116t-33.5 -175.5q0 -100 33.5 -175t95.5 -116.5t145 -41.5q90 0 148.5 46 t71.5 122h96q-13 -77 -56 -134t-109.5 -87.5t-150.5 -30.5zM371 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 620,
    d: "M338 -12q-79 0 -141.5 38.5t-98.5 108.5t-36 165q0 96 36 166t98.5 108t141.5 38q60 0 111 -22.5t87 -68t51 -115.5h-94q-16 65 -57.5 94.5t-97.5 29.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63q59 0 101.5 32t58.5 102h92q-14 -72 -50.5 -120t-88 -72 t-113.5 -24zM275 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 790,
    d: "M434 -12q-109 0 -192 52.5t-129.5 146.5t-46.5 218t46.5 218t129.5 146.5t192 52.5q84 0 150.5 -30.5t109.5 -87t56 -134.5h-96q-13 77 -71.5 122.5t-148.5 45.5q-83 0 -145 -41.5t-95.5 -116t-33.5 -175.5q0 -100 33.5 -175t95.5 -116.5t145 -41.5q90 0 148.5 46 t71.5 122h96q-13 -77 -56 -134t-109.5 -87.5t-150.5 -30.5zM434 900q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 620,
    d: "M338 -12q-79 0 -141.5 38.5t-98.5 108.5t-36 165q0 96 36 166t98.5 108t141.5 38q60 0 111 -22.5t87 -68t51 -115.5h-94q-16 65 -57.5 94.5t-97.5 29.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63q59 0 101.5 32t58.5 102h92q-14 -72 -50.5 -120t-88 -72 t-113.5 -24zM338 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 790,
    d: "M434 -12q-109 0 -192 52.5t-129.5 146.5t-46.5 218t46.5 218t129.5 146.5t192 52.5q84 0 150.5 -30.5t109.5 -87t56 -134.5h-96q-13 77 -71.5 122.5t-148.5 45.5q-83 0 -145 -41.5t-95.5 -116t-33.5 -175.5q0 -100 33.5 -175t95.5 -116.5t145 -41.5q90 0 148.5 46 t71.5 122h96q-13 -77 -56 -134t-109.5 -87.5t-150.5 -30.5zM387 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 620,
    d: "M338 -12q-79 0 -141.5 38.5t-98.5 108.5t-36 165q0 96 36 166t98.5 108t141.5 38q60 0 111 -22.5t87 -68t51 -115.5h-94q-16 65 -57.5 94.5t-97.5 29.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63q59 0 101.5 32t58.5 102h92q-14 -72 -50.5 -120t-88 -72 t-113.5 -24zM291 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 810,
    d: "M114 0v810h243q122 0 211.5 -49t138.5 -140t49 -216q0 -124 -49 -215t-138.5 -140.5t-211.5 -49.5h-243zM206 82h151q99 0 167 40.5t103 113t35 169.5q0 146 -78 234.5t-227 88.5h-151v-646zM341 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 780,
    d: "M311 -12q-75 0 -131 39t-87 109.5t-31 163.5q0 94 31 164t87 109t131 39q137 0 189 -114h4v342h90v-840h-90v102h-4q-52 -114 -189 -114zM334 68q81 0 125.5 51t44.5 132v98q0 81 -44.5 132t-125.5 51q-82 0 -132 -63.5t-50 -168.5t50 -168.5t132 -63.5zM654 570l64 270 h90v-4l-92 -266h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 840,
    d: "M144 0v383h-114v74h114v353h243q122 0 211.5 -49t138.5 -140t49 -216q0 -124 -49 -215t-138.5 -140.5t-211.5 -49.5h-243zM236 82h151q99 0 167 40.5t103 113t35 169.5q0 146 -78 234.5t-227 88.5h-151v-271h238v-74h-238v-301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M311 -12q-75 0 -131 38.5t-87 105.5t-31 153t31 153t87 105.5t131 38.5q137 0 189 -114h4v219h-242v66h242v87h90v-87h84v-66h-84v-687h-90v102h-4q-52 -114 -189 -114zM334 68q81 0 125.5 50t44.5 123v88q0 74 -44.5 123.5t-125.5 49.5q-55 0 -96 -28t-63.5 -77 t-22.5 -112q0 -62 22.5 -111.5t63.5 -77.5t96 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM183 927v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM141 717v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM367 900q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM325 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM551 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM403 -240q-46 0 -68 23.5t-22 66.5q0 53 34.5 99.5t74.5 72.5h50q-42 -40 -62.5 -78t-20.5 -91v-27h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 680,
    d: "M620 0h-506v810h506v-82h-414v-268h394v-80h-394v-298h414v-82zM320 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 650,
    d: "M340 -12q-80 0 -143 38.5t-99 109t-36 166.5q0 95 35.5 164.5t97 107.5t139.5 38q74 0 131 -34t90 -96.5t33 -147.5v-45h-440q4 -100 56.5 -159.5t134.5 -59.5q58 0 99.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5t-85.5 -65.5t-112.5 -23zM153 361h348q-7 80 -52.5 125.5 t-115.5 45.5t-118 -45.5t-62 -125.5zM278 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 840,
    d: "M425 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48.5 218t133.5 146.5t194 52.5q84 0 150 -30.5t108.5 -87t55.5 -134.5h-96q-13 77 -70.5 122.5t-147.5 45.5q-84 0 -147.5 -41.5t-99 -116.5t-35.5 -175q0 -97 35 -173.5t97.5 -120.5t142.5 -44q67 0 119 26t82 71 t30 100v58h-244v80h244q43 0 66.5 -23.5t23.5 -66.5v-312h-88v126h-4q-22 -59 -86 -98.5t-153 -39.5zM414 890q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M323 -252q-108 0 -180 52.5t-84 139.5h96q11 -52 55 -81t111 -29q86 0 134.5 48.5t48.5 133.5v102h-4q-22 -54 -70 -84t-113 -30q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q65 0 113 -30t70 -83h4v101h90v-595q0 -118 -73.5 -187.5 t-197.5 -69.5zM338 82q75 0 120.5 49t45.5 129v92q0 80 -45.5 129t-120.5 49q-85 0 -135.5 -61t-50.5 -163t50.5 -163t135.5 -61zM344 680q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 840,
    d: "M425 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48.5 218t133.5 146.5t194 52.5q84 0 150 -30.5t108.5 -87t55.5 -134.5h-96q-13 77 -70.5 122.5t-147.5 45.5q-84 0 -147.5 -41.5t-99 -116.5t-35.5 -175q0 -97 35 -173.5t97.5 -120.5t142.5 -44q67 0 119 26t82 71 t30 100v58h-244v80h244q43 0 66.5 -23.5t23.5 -66.5v-312h-88v126h-4q-22 -59 -86 -98.5t-153 -39.5zM415 900q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M323 -252q-108 0 -180 52.5t-84 139.5h96q11 -52 55 -81t111 -29q86 0 134.5 48.5t48.5 133.5v102h-4q-22 -54 -70 -84t-113 -30q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q65 0 113 -30t70 -83h4v101h90v-595q0 -118 -73.5 -187.5 t-197.5 -69.5zM338 82q75 0 120.5 49t45.5 129v92q0 80 -45.5 129t-120.5 49q-85 0 -135.5 -61t-50.5 -163t50.5 -163t135.5 -61zM345 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 840,
    d: "M425 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 124 48.5 218t133.5 146.5t194 52.5q84 0 150 -30.5t108.5 -87t55.5 -134.5h-96q-13 77 -70.5 122.5t-147.5 45.5q-84 0 -147.5 -41.5t-99 -116.5t-35.5 -175q0 -97 35 -173.5t97.5 -120.5t142.5 -44q67 0 119 26t82 71 t30 100v58h-244v80h244q43 0 66.5 -23.5t23.5 -66.5v-312h-88v126h-4q-22 -59 -86 -98.5t-153 -39.5zM346 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    d: "M323 -252q-108 0 -180 52.5t-84 139.5h96q11 -52 55 -81t111 -29q86 0 134.5 48.5t48.5 133.5v102h-4q-22 -54 -70 -84t-113 -30q-76 0 -133.5 38.5t-89.5 107.5t-32 160t32 160t89.5 107.5t133.5 38.5q65 0 113 -30t70 -83h4v101h90v-595q0 -118 -73.5 -187.5 t-197.5 -69.5zM338 82q75 0 120.5 49t45.5 129v92q0 80 -45.5 129t-120.5 49q-85 0 -135.5 -61t-50.5 -163t50.5 -163t135.5 -61zM298 702v126q0 49 26.5 75.5t75.5 26.5h29v-60h-23q-22 0 -35 -12t-13 -36v-22h38v-98h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 910,
    d: "M144 0v627h-114v66h114v117h92v-117h438v117h92v-117h114v-66h-114v-627h-92v349h-438v-349h-92zM236 431h438v196h-438v-196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    d: "M96 0v687h-84v66h84v87h90v-87h242v-66h-242v-207h4q26 47 74 74.5t112 27.5q66 0 116 -30.5t78 -85t28 -126.5v-340h-90v329q0 82 -42.5 127.5t-118.5 45.5t-118.5 -45.5t-42.5 -127.5v-329h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM-24 927v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM21 717v66h248v-66h-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM137 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM145 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5zM121 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 320,
    d: "M114 0v810h92v-810h-92zM160 900q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 760,
    d: "M114 0v810h92v-810h-92zM350 0v82h204v728h92v-720q0 -45 -24 -67.5t-66 -22.5h-206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 573,
    d: "M100 0v600h90v-600h-90zM145 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5zM272 -240v72h121v768h90v-750q0 -45 -24 -67.5t-66 -22.5h-121zM438 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5 t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 740,
    d: "M114 0v810h92v-404h4l380 404h114l-341 -352l353 -458h-114l-306 396l-90 -79v-317h-92zM320 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 620,
    d: "M96 0v840h90v-528h4l279 288h109l-251 -254l275 -346h-111l-226 290l-79 -70v-220h-90zM226 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 640,
    d: "M114 0v810h92v-728h404v-82h-496zM97 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 290,
    d: "M100 0v840h90v-840h-90zM82 920v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 640,
    d: "M114 0v810h92v-728h404v-82h-496zM278 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 290,
    d: "M100 0v840h90v-840h-90zM61 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 640,
    d: "M114 0v810h92v-728h404v-82h-496zM266 540l64 270h90v-4l-92 -266h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 380,
    d: "M100 0v840h90v-840h-90zM253 570l64 270h90v-4l-92 -266h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 670,
    d: "M144 0v320l-114 -61v82l114 61v408h92v-358l238 128v-82l-238 -128v-287h404v-83h-496z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 350,
    d: "M130 0v330l-100 -54v72l100 54v438h90v-390l100 54v-72l-100 -54v-378h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 880,
    d: "M766 0h-106l-456 681h-4v-681h-86v810h106l456 -681h4v681h86v-810zM387 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    d: "M96 0v600h90v-100h4q26 54 74 82.5t112 28.5q66 0 116 -31t78 -85.5t28 -125.5v-369h-90v355q0 81 -42.5 127.5t-118.5 46.5t-118.5 -46.5t-42.5 -127.5v-355h-90zM284 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 880,
    d: "M766 0h-106l-456 681h-4v-681h-86v810h106l456 -681h4v681h86v-810zM346 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    d: "M96 0v600h90v-100h4q26 54 74 82.5t112 28.5q66 0 116 -31t78 -85.5t28 -125.5v-369h-90v355q0 81 -42.5 127.5t-118.5 46.5t-118.5 -46.5t-42.5 -127.5v-355h-90zM263 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 880,
    d: "M766 0h-106l-456 681h-4v-681h-86v810h106l456 -681h4v681h86v-810zM403 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    d: "M96 0v600h90v-100h4q26 54 74 82.5t112 28.5q66 0 116 -31t78 -85.5t28 -125.5v-369h-90v355q0 81 -42.5 127.5t-118.5 46.5t-118.5 -46.5t-42.5 -127.5v-355h-90zM300 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 880,
    d: "M531 -180v80h149v100l-476 681h-4v-681h-86v810h106l456 -651h4v651h86v-900q0 -45 -24 -67.5t-66 -22.5h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    d: "M375 -240v72h133v523q0 81 -42.5 127.5t-118.5 46.5t-118.5 -46.5t-42.5 -127.5v-355h-90v600h90v-100h4q26 54 74 82.5t112 28.5q66 0 116 -31t78 -85.5t28 -125.5v-519q0 -45 -24 -67.5t-66 -22.5h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM251 927v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM156 717v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 870,
    d: "M435 -12q-106 0 -189.5 51.5t-131.5 145t-48 220.5q0 128 48 221.5t131.5 144.5t189.5 51q107 0 190.5 -50.5t131 -144t47.5 -222.5q0 -127 -48 -221t-131 -145t-190 -51zM435 72q84 0 146 41.5t95.5 116.5t33.5 175q0 101 -33.5 176t-95.5 116t-146 41t-145.5 -41 t-95.5 -116t-34 -176q0 -100 34 -175t95.5 -116.5t145.5 -41.5zM474 890v4l97 175h103v-4l-143 -175h-57zM278 890v4l96 175h104v-4l-144 -175h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 680,
    d: "M340 -12q-80 0 -143 38.5t-99 108.5t-36 165q0 96 36 166t99 108t143 38q82 0 144.5 -38t98 -108t35.5 -166q0 -95 -35.5 -165.5t-98.5 -108.5t-144 -38zM340 70q87 0 137.5 63t50.5 167q0 105 -50.5 167.5t-137.5 62.5q-85 0 -136.5 -62.5t-51.5 -167.5 q0 -104 51.5 -167t136.5 -63zM379 680v4l97 175h103v-4l-143 -175h-57zM183 680v4l96 175h104v-4l-144 -175h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1230,
    d: "M425 -12q-105 0 -186 53t-127 147.5t-46 216.5q0 123 46 217t127 147t186 53q89 0 152 -39.5t85 -98.5h4v126h504v-82h-414v-268h394v-80h-394v-298h414v-82h-504v126h-4q-22 -59 -85 -98.5t-152 -39.5zM435 67q66 0 118 26t81.5 71t29.5 100v282q0 56 -29.5 100.5 t-81.5 70.5t-118 26q-80 0 -142.5 -44t-97.5 -120t-35 -174q0 -97 35 -173.5t97.5 -120.5t142.5 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1110,
    d: "M338 -12q-79 0 -141.5 38.5t-98.5 108.5t-36 165q0 96 36 166t98.5 108t141.5 38q75 0 135 -33.5t94 -98.5h4q34 64 92.5 98t130.5 34q73 0 129.5 -34t89.5 -96.5t33 -147.5v-45h-436q4 -100 56 -159.5t133 -59.5q56 0 97.5 29.5t55.5 79.5h92q-13 -60 -48 -102.5 t-85 -65.5t-111 -23q-73 0 -133.5 35.5t-95.5 102.5h-4q-34 -67 -94 -102.5t-135 -35.5zM338 70q86 0 136 63t50 167q0 105 -50 167.5t-136 62.5q-84 0 -135 -62.5t-51 -167.5q0 -104 51 -167t135 -63zM615 361h344q-7 80 -52.5 125.5t-113.5 45.5t-116 -45.5t-62 -125.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 790,
    d: "M114 0v810h335q73 0 128 -26t86 -75.5t31 -120.5q0 -52 -21.5 -95.5t-68.5 -72.5v-5q43 0 66.5 -23.5t23.5 -66.5v-325h-92v340h-396v-340h-92zM206 418h233q73 0 118 40.5t45 115.5t-45 115.5t-118 40.5h-233v-312zM295 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 460,
    d: "M108 0v600h85v-127h4q20 59 67.5 95t116.5 36h43v-80h-48q-85 0 -131.5 -56t-46.5 -152v-316h-90zM203 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 790,
    d: "M114 0v810h335q73 0 128 -26t86 -75.5t31 -120.5q0 -52 -21.5 -95.5t-68.5 -72.5v-5q43 0 66.5 -23.5t23.5 -66.5v-325h-92v340h-396v-340h-92zM206 418h233q73 0 118 40.5t45 115.5t-45 115.5t-118 40.5h-233v-312z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 460,
    d: "M108 0v600h85v-127h4q20 59 67.5 95t116.5 36h43v-80h-48q-85 0 -131.5 -56t-46.5 -152v-316h-90zM69 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 790,
    d: "M114 0v810h335q73 0 128 -26t86 -75.5t31 -120.5q0 -52 -21.5 -95.5t-68.5 -72.5v-5q43 0 66.5 -23.5t23.5 -66.5v-325h-92v340h-396v-340h-92zM206 418h233q73 0 118 40.5t45 115.5t-45 115.5t-118 40.5h-233v-312zM311 890l-137 175v4h62l120 -108l122 108h64v-4 l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 460,
    d: "M108 0v600h85v-127h4q20 59 67.5 95t116.5 36h43v-80h-48q-85 0 -131.5 -56t-46.5 -152v-316h-90zM219 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 720,
    d: "M370 -12q-93 0 -162.5 32t-109.5 88.5t-45 131.5h98q9 -82 67.5 -125t154.5 -43q92 0 141.5 38.5t49.5 107.5q0 56 -35.5 92t-110.5 52l-125 27q-98 21 -151 74t-53 135q0 65 32.5 115.5t92.5 79.5t141 29q84 0 146.5 -30t100.5 -84t46 -126h-98q-13 77 -65 116.5 t-135 39.5q-77 0 -124 -35.5t-47 -97.5q0 -49 33.5 -83t109.5 -51l130 -29q101 -22 151.5 -76.5t50.5 -140.5q0 -107 -75 -172t-209 -65zM290 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 560,
    d: "M292 -12q-106 0 -172 52.5t-72 139.5h90q6 -55 46.5 -84.5t110.5 -29.5q65 0 99 25.5t34 72.5q0 73 -101 95l-95 20q-160 34 -160 158q0 78 58 126.5t152 48.5q92 0 153.5 -49.5t70.5 -132.5h-88q-10 50 -46.5 77t-92.5 27t-89.5 -24.5t-33.5 -66.5q0 -34 24 -54.5 t76 -31.5l95 -20q80 -17 120.5 -58.5t40.5 -107.5q0 -84 -59 -133.5t-161 -49.5zM217 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 720,
    d: "M370 -12q-93 0 -162.5 32t-109.5 88.5t-45 131.5h98q9 -82 67.5 -125t154.5 -43q92 0 141.5 38.5t49.5 107.5q0 56 -35.5 92t-110.5 52l-125 27q-98 21 -151 74t-53 135q0 65 32.5 115.5t92.5 79.5t141 29q84 0 146.5 -30t100.5 -84t46 -126h-98q-13 77 -65 116.5 t-135 39.5q-77 0 -124 -35.5t-47 -97.5q0 -49 33.5 -83t109.5 -51l130 -29q101 -22 151.5 -76.5t50.5 -140.5q0 -107 -75 -172t-209 -65zM264 -268v66h133v29q0 41 -29.5 56.5t-74.5 20.5l65 126h60l-45 -91q41 -8 69.5 -33t28.5 -84q0 -37 -23 -63.5t-67 -26.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 560,
    d: "M292 -12q-106 0 -172 52.5t-72 139.5h90q6 -55 46.5 -84.5t110.5 -29.5q65 0 99 25.5t34 72.5q0 73 -101 95l-95 20q-160 34 -160 158q0 78 58 126.5t152 48.5q92 0 153.5 -49.5t70.5 -132.5h-88q-10 50 -46.5 77t-92.5 27t-89.5 -24.5t-33.5 -66.5q0 -34 24 -54.5 t76 -31.5l95 -20q80 -17 120.5 -58.5t40.5 -107.5q0 -84 -59 -133.5t-161 -49.5zM172 -268v66h133v29q0 41 -29.5 56.5t-74.5 20.5l65 126h60l-45 -91q41 -8 69.5 -33t28.5 -84q0 -37 -23 -63.5t-67 -26.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 720,
    d: "M370 -12q-93 0 -162.5 32t-109.5 88.5t-45 131.5h98q9 -82 67.5 -125t154.5 -43q92 0 141.5 38.5t49.5 107.5q0 56 -35.5 92t-110.5 52l-125 27q-98 21 -151 74t-53 135q0 65 32.5 115.5t92.5 79.5t141 29q84 0 146.5 -30t100.5 -84t46 -126h-98q-13 77 -65 116.5 t-135 39.5q-77 0 -124 -35.5t-47 -97.5q0 -49 33.5 -83t109.5 -51l130 -29q101 -22 151.5 -76.5t50.5 -140.5q0 -107 -75 -172t-209 -65zM306 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 560,
    d: "M292 -12q-106 0 -172 52.5t-72 139.5h90q6 -55 46.5 -84.5t110.5 -29.5q65 0 99 25.5t34 72.5q0 73 -101 95l-95 20q-160 34 -160 158q0 78 58 126.5t152 48.5q92 0 153.5 -49.5t70.5 -132.5h-88q-10 50 -46.5 77t-92.5 27t-89.5 -24.5t-33.5 -66.5q0 -34 24 -54.5 t76 -31.5l95 -20q80 -17 120.5 -58.5t40.5 -107.5q0 -84 -59 -133.5t-161 -49.5zM233 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    d: "M391 0h-92v728h-275v82h642v-82h-275v-728zM298 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 400,
    d: "M209 0q-40 0 -63 21.5t-23 64.5v442h-105v72h106v180h88v-180h150v-72h-149v-456h163v-72h-167zM272 690l64 270h90v-4l-92 -266h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM227 927v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM161 717v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM410 890q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50 t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM344 680q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80 t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM411 858q-37 0 -68.5 18t-50 48.5t-18.5 68.5q0 39 18.5 69.5t50 48t68.5 17.5q38 0 69 -17.5t49.5 -48 t18.5 -69.5q0 -38 -18.5 -68.5t-49.5 -48.5t-69 -18zM411 919q30 0 52 21t22 53t-22 53t-52 21t-52 -21t-22 -53t22 -53t52 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM345 678q-33 0 -61 16t-44.5 43t-16.5 61t16.5 61t44.5 43t61 16q34 0 61.5 -16t44 -43t16.5 -61 t-16.5 -61t-44 -43t-61.5 -16zM345 734q26 0 45 18t19 46t-19 46t-45 18t-45 -18t-19 -46t19 -46t45 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM450 890v4l97 175h103v-4l-143 -175h-57zM254 890v4l96 175h104v-4l-144 -175h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM384 680v4l97 175h103v-4l-143 -175h-57zM188 680v4l96 175h104v-4l-144 -175h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 820,
    d: "M407 -12q-99 0 -167 36.5t-103 103.5t-35 158v524h94v-524q0 -102 54 -157t162 -55q110 0 162 58.5t52 152.5v525h92v-526q0 -86 -34 -153t-103 -105t-174 -38zM430 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66 h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    d: "M311 -11q-65 0 -114.5 30t-77 83.5t-27.5 122.5v375h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -74 -87.5t-115 -30.5zM525 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24 h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1080,
    d: "M245 0l-209 810h98l163 -696h4l187 696h96l196 -696h4l162 696h98l-209 -810h-102l-196 699h-4l-186 -699h-102zM352 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 900,
    d: "M189 0l-171 600h92l133 -492h4l156 492h96l156 -492h4l133 492h90l-171 -600h-102l-157 498h-4l-157 -498h-102zM266 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    d: "M299 0v306l-287 504h106l228 -407h4l228 407h100l-287 -502v-308h-92zM164 890v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 580,
    d: "M60 -240v72h138l60 164l-252 604h93l202 -490h4l179 490h90l-227 -600l-57 -150q-16 -42 -32 -66t-58 -24h-140zM106 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    d: "M299 0v306l-287 504h106l228 -407h4l228 407h100l-287 -502v-308h-92zM465 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM231 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5 t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 680,
    d: "M54 0v72l450 656h-432v82h542v-72l-450 -656h462v-82h-572zM277 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 560,
    d: "M54 0v66l344 460h-326v74h428v-66l-344 -460h350v-74h-452zM217 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 680,
    d: "M54 0v72l450 656h-432v82h542v-72l-450 -656h462v-82h-572zM340 900q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 560,
    d: "M54 0v66l344 460h-326v74h428v-66l-344 -460h350v-74h-452zM280 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 680,
    d: "M54 0v72l450 656h-432v82h542v-72l-450 -656h462v-82h-572zM293 890l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 560,
    d: "M54 0v66l344 460h-326v74h428v-66l-344 -460h350v-74h-452zM233 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 660,
    d: "M273 -180v539h-175v72h176v289q0 45 24 67.5t66 22.5h210v-72h-212v-307h200v-72h-199v-539h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 720,
    d: "M370 -12q-93 0 -162.5 32t-109.5 88.5t-45 131.5h98q9 -82 67.5 -125t154.5 -43q92 0 141.5 38.5t49.5 107.5q0 56 -35.5 92t-110.5 52l-125 27q-98 21 -151 74t-53 135q0 65 32.5 115.5t92.5 79.5t141 29q84 0 146.5 -30t100.5 -84t46 -126h-98q-13 77 -65 116.5 t-135 39.5q-77 0 -124 -35.5t-47 -97.5q0 -49 33.5 -83t109.5 -51l130 -29q101 -22 151.5 -76.5t50.5 -140.5q0 -107 -75 -172t-209 -65zM288 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 560,
    d: "M292 -12q-106 0 -172 52.5t-72 139.5h90q6 -55 46.5 -84.5t110.5 -29.5q65 0 99 25.5t34 72.5q0 73 -101 95l-95 20q-160 34 -160 158q0 78 58 126.5t152 48.5q92 0 153.5 -49.5t70.5 -132.5h-88q-10 50 -46.5 77t-92.5 27t-89.5 -24.5t-33.5 -66.5q0 -34 24 -54.5 t76 -31.5l95 -20q80 -17 120.5 -58.5t40.5 -107.5q0 -84 -59 -133.5t-161 -49.5zM196 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    d: "M391 0h-92v728h-275v82h642v-82h-275v-728zM261 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 400,
    d: "M209 0q-40 0 -63 21.5t-23 64.5v442h-105v72h106v180h88v-180h150v-72h-149v-456h163v-72h-167zM166 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 283,
    d: "M-18 -240v72h121v768h90v-750q0 -45 -24 -67.5t-66 -22.5h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 600,
    d: "M116 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 600,
    d: "M253 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 600,
    d: "M300 680q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 600,
    d: "M300 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 600,
    d: "M300 678q-33 0 -61 16t-44.5 43t-16.5 61t16.5 61t44.5 43t61 16q34 0 61.5 -16t44 -43t16.5 -61t-16.5 -61t-44 -43t-61.5 -16zM300 734q26 0 45 18t19 46t-19 46t-45 18t-45 -18t-19 -46t19 -46t45 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 600,
    d: "M294 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 600,
    d: "M96 678q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 600,
    d: "M298 680v4l97 175h103v-4l-143 -175h-57zM102 680v4l96 175h104v-4l-144 -175h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M345 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M189 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M116 680v4l137 175h92l139 -175v-4h-64l-122 105l-120 -105h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M96 678q6 68 37 106t83 38q34 0 63.5 -18t56.5 -36t51 -18q49 0 63 72h54q-7 -66 -38 -105t-83 -39q-32 0 -61.5 18t-56.5 36t-52 18q-27 0 -41.5 -17.5t-21.5 -54.5h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M116 717v66h368v-66h-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M300 680q-50 0 -86 17t-57.5 50t-26.5 80h60q7 -33 32 -53t78 -20t78 20t32 53h60q-5 -47 -26 -80t-57.5 -50t-86.5 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M300 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M417 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM183 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M300 678q-33 0 -61 16t-44.5 43t-16.5 61t16.5 61t44.5 43t61 16q34 0 61.5 -16t44 -43t16.5 -61t-16.5 -61t-44 -43t-61.5 -16zM300 734q26 0 45 18t19 46t-19 46t-45 18t-45 -18t-19 -46t19 -46t45 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M298 680v4l97 175h103v-4l-143 -175h-57zM102 680v4l96 175h104v-4l-144 -175h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M253 680l-137 175v4h62l120 -108l122 108h64v-4l-139 -175h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\u0312",
    horizAdvX: 0,
    d: "M253 702v126q0 49 26.5 75.5t75.5 26.5h29v-60h-23q-22 0 -35 -12t-13 -36v-22h38v-98h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M216 -330v60h23q23 0 35.5 12t12.5 36v22h-38v98h98v-126q0 -49 -26.5 -75.5t-75.5 -26.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    horizAdvX: 0,
    d: "M192 -268v66h133v29q0 41 -29.5 56.5t-74.5 20.5l65 126h60l-45 -91q41 -8 69.5 -33t28.5 -84q0 -37 -23 -63.5t-67 -26.5h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M294 -240q-46 0 -68 23.5t-22 66.5q0 51 34.5 96t74.5 70l50 -16q-42 -35 -62.5 -69t-20.5 -81v-24h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    d: "M92 -240v840h90v-355q0 -81 41 -127.5t114 -46.5q75 0 121 48t46 126v355h90v-600h-90v107h-4q-25 -57 -73 -87.5t-110 -30.5q-37 0 -71 13t-62 40h-4v-282h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1080,
    d: "M245 0l-209 810h98l163 -696h4l187 696h96l196 -696h4l162 696h98l-209 -810h-102l-196 699h-4l-186 -699h-102zM533 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 900,
    d: "M189 0l-171 600h92l133 -492h4l156 492h96l156 -492h4l133 492h90l-171 -600h-102l-157 498h-4l-157 -498h-102zM447 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1080,
    d: "M245 0l-209 810h98l163 -696h4l187 696h96l196 -696h4l162 696h98l-209 -810h-102l-196 699h-4l-186 -699h-102zM473 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 900,
    d: "M189 0l-171 600h92l133 -492h4l156 492h96l156 -492h4l133 492h90l-171 -600h-102l-157 498h-4l-157 -498h-102zM387 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1080,
    d: "M245 0l-209 810h98l163 -696h4l187 696h96l196 -696h4l162 696h98l-209 -810h-102l-196 699h-4l-186 -699h-102zM653 901q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM419 901q-24 0 -41.5 17.5t-17.5 41.5 t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 900,
    d: "M189 0l-171 600h92l133 -492h4l156 492h96l156 -492h4l133 492h90l-171 -600h-102l-157 498h-4l-157 -498h-102zM567 691q-24 0 -41.5 17.5t-17.5 41.5t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5zM333 691q-24 0 -41.5 17.5t-17.5 41.5 t17.5 41.5t41.5 17.5t41.5 -17.5t17.5 -41.5t-17.5 -41.5t-41.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 810,
    d: "M294 -1v82h188q83 0 134.5 42.5t51.5 123.5t-51 122t-134 41h-54v64l200 250v4h-423v-728h-92v720q0 43 23.5 66.5t66.5 23.5h526v-82l-194 -237v-4q65 -6 115.5 -37t79.5 -82.5t29 -120.5q0 -75 -35 -130.5t-94.5 -85.5t-133.5 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    d: "M299 0v306l-287 504h106l228 -407h4l228 407h100l-287 -502v-308h-92zM345 890l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 580,
    d: "M60 -240v72h138l60 164l-252 604h93l202 -490h4l179 490h90l-227 -600l-57 -150q-16 -42 -32 -66t-58 -24h-140zM287 680l-156 175v4h112l110 -175v-4h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 600,
    d: "M48 261v78h504v-78h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1200,
    d: "M48 259v82h1104v-82h-1104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 260,
    d: "M70 532v164q0 54 29.5 84t84.5 30h42v-60h-36q-25 0 -39.5 -13.5t-14.5 -40.5v-44h54v-120h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 260,
    d: "M34 532v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 260,
    d: "M34 -158v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 520,
    d: "M70 532v164q0 54 29.5 84t84.5 30h42v-60h-36q-25 0 -39.5 -13.5t-14.5 -40.5v-44h54v-120h-120zM330 532v164q0 54 29.5 84t84.5 30h42v-60h-36q-25 0 -39.5 -13.5t-14.5 -40.5v-44h54v-120h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 520,
    d: "M34 532v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42zM294 532v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 520,
    d: "M34 -158v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42zM294 -158v60h36q26 0 40 13.5t14 40.5v44h-54v120h120v-164q0 -54 -29.5 -84t-84.5 -30h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 620,
    d: "M278 0l-8 277v281l-89 -7h-120v80h120l97 -8l-8 97v120h80v-120l-8 -97l97 8h120v-80h-120l-89 7v-281l-8 -277h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 620,
    d: "M270 0v120l8 97l-97 -8h-120v80h120l95 -8v278l-95 -8h-120v80h120l97 -8l-8 97v120h80v-120l-8 -97l97 8h120v-80h-120l-95 8v-278l95 8h120v-80h-120l-97 8l8 -97v-120h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 421,
    d: "M210 255q-41 0 -75.5 20t-54.5 54.5t-20 75.5q0 42 20 76t54.5 54t75.5 20q42 0 76 -20t54 -54t20 -76q0 -41 -20 -75.5t-54 -54.5t-76 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1200,
    d: "M195 -12q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM600 -12q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM1005 -12q-28 0 -48.5 20.5t-20.5 48.5 q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1440,
    d: "M230 378q-76 0 -123 56.5t-47 165.5t47 165.5t123 56.5q74 0 122 -56.5t48 -165.5t-48 -165.5t-122 -56.5zM230 440q43 0 69.5 39.5t26.5 120.5t-26.5 120.5t-69.5 39.5q-44 0 -70 -39.5t-26 -120.5t26 -120.5t70 -39.5zM750 -12q-76 0 -123 56.5t-47 165.5t47 165.5 t123 56.5q74 0 122 -56.5t48 -165.5t-48 -165.5t-122 -56.5zM750 50q43 0 69.5 39.5t26.5 120.5t-26.5 120.5t-69.5 39.5q-44 0 -70 -39.5t-26 -120.5t26 -120.5t70 -39.5zM1210 -12q-76 0 -123 56.5t-47 165.5t47 165.5t123 56.5q74 0 122 -56.5t48 -165.5t-48 -165.5 t-122 -56.5zM1210 50q43 0 69.5 39.5t26.5 120.5t-26.5 120.5t-69.5 39.5q-44 0 -70 -39.5t-26 -120.5t26 -120.5t70 -39.5zM228 0l446 810h78l-446 -810h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 340,
    d: "M210 61l-168 239l168 239h88l-168 -239l168 -239h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 340,
    d: "M42 61l168 239l-168 239h88l168 -239l-168 -239h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 60,
    d: "M-232 0l446 810h78l-446 -810h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 660,
    d: "M374 -12q-77 0 -138 35.5t-98.5 103t-42.5 162.5h-77v68h76v96h-76v68h77q5 95 42.5 162t98.5 103t138 36q60 0 112.5 -23.5t89.5 -72.5t52 -126h-95q-15 76 -59 107.5t-100 31.5q-79 0 -131 -55.5t-61 -162.5h257v-68h-258v-96h258v-68h-257q8 -106 60.5 -162t131.5 -56 q58 0 103 34t60 111h93q-14 -77 -51.5 -128t-90.5 -75.5t-114 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1000,
    d: "M234 390h-78v348h-142v72h362v-72h-142v-348zM464 390v420h107l122 -313h4l122 313h107v-420h-78v316h-4l-119 -316h-65l-119 317h-5v-317h-72z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 660,
    d: "M78 367v76h504v-76h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni004A0301",
    horizAdvX: 440,
    d: "M30 0v82h204v728h92v-720q0 -45 -24 -67.5t-66 -22.5h-206zM217 890v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 290,
    d: "M100 0v600h90v-600h-90zM145 690q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni006A0301",
    horizAdvX: 283,
    d: "M-18 -240v72h121v768h90v-750q0 -45 -24 -67.5t-66 -22.5h-121zM85 680v4l108 175h114v-4l-157 -175h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf",
    horizAdvX: 700,
    d: "M350 -12q-141 0 -214 106t-73 311t73 311t214 106t214 -106t73 -311t-73 -311t-214 -106zM350 70q98 0 147.5 84t49.5 251t-49.5 251t-147.5 84t-147.5 -84t-49.5 -251t49.5 -251t147.5 -84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lf",
    horizAdvX: 480,
    d: "M258 0v705l-206 -159h-4v95l222 169h78v-810h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lf",
    horizAdvX: 620,
    d: "M52 0v72l305 335q41 45 63.5 76t32 57t9.5 55q0 66 -41.5 105.5t-109.5 39.5q-73 0 -118 -45t-53 -125h-88q5 76 38 132.5t90 88t132 31.5q69 0 123.5 -28t85.5 -78.5t31 -116.5q0 -56 -27.5 -109t-87.5 -117l-267 -287v-4h398v-82h-516z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lf",
    horizAdvX: 660,
    d: "M324 -12q-115 0 -184.5 58t-79.5 164h88q6 -67 52.5 -103.5t119.5 -36.5q74 0 124 43.5t50 116.5q0 72 -49 112.5t-125 40.5h-86v76h93q74 0 111.5 41.5t37.5 96.5q0 65 -44 104t-106 39q-73 0 -114 -40.5t-52 -99.5h-86q6 64 39 114t88.5 79t127.5 29q65 0 118 -25.5 t85 -73.5t32 -115q0 -64 -38 -112t-97 -69v-4q66 -16 109.5 -66.5t43.5 -130.5q0 -78 -35.5 -131t-94 -80t-128.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lf",
    d: "M437 0v200h-397v70l397 540h88v-530h125v-80h-125v-200h-88zM131 280h310v416h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lf",
    horizAdvX: 660,
    d: "M324 -12q-115 0 -184.5 58t-79.5 164h88q6 -66 51.5 -103t120.5 -37q77 0 125.5 52t48.5 134q0 83 -48.5 135t-125.5 52q-49 0 -91 -19t-67 -52h-77l50 438h405v-82h-328l-30 -255h4q27 25 64.5 37.5t80.5 12.5q75 0 131.5 -33t88 -92t31.5 -137q0 -80 -33 -141.5 t-91 -96.5t-134 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lf",
    horizAdvX: 670,
    d: "M354 -12q-139 0 -213.5 100t-74.5 287q0 140 35.5 240t101.5 153.5t157 53.5q88 0 153.5 -47.5t87.5 -144.5h-90q-16 55 -56 82.5t-95 27.5q-92 0 -147 -86.5t-60 -245.5h5q28 54 81 84.5t116 30.5q75 0 132 -33t88.5 -92t31.5 -137q0 -80 -32 -142t-89 -96.5t-132 -34.5 zM350 70q74 0 121.5 52t47.5 134q0 53 -23.5 95.5t-64.5 67t-96 24.5q-49 0 -88 -20.5t-62 -55.5t-23 -81q0 -62 25 -111t68 -77t95 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lf",
    horizAdvX: 640,
    d: "M161 0l325 726h-426v84h520v-77l-321 -733h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lf",
    horizAdvX: 660,
    d: "M330 -12q-71 0 -131 27t-96.5 79.5t-36.5 128.5q0 77 43 126.5t98 71.5v4q-47 22 -82 71t-35 110q0 69 32.5 117t87 73.5t120.5 25.5q67 0 121 -25.5t86.5 -73.5t32.5 -117q0 -61 -35 -107t-82 -68v-4q56 -22 98.5 -74.5t42.5 -129.5q0 -76 -36.5 -128.5t-96.5 -79.5 t-131 -27zM330 68q47 0 87 19.5t64.5 55.5t24.5 84q0 49 -24.5 84.5t-64.5 55t-87 19.5t-87 -19.5t-64.5 -55t-24.5 -84.5q0 -48 24.5 -84t64.5 -55.5t87 -19.5zM330 464q62 0 107 37.5t45 101.5q0 65 -45 102t-107 37t-107 -37t-45 -102q0 -64 45 -101.5t107 -37.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lf",
    horizAdvX: 670,
    d: "M315 -12q-100 0 -168.5 53.5t-88.5 156.5h90q16 -65 61 -96.5t106 -31.5q87 0 136.5 83.5t53.5 257.5h-4q-25 -49 -75 -80.5t-117 -31.5q-72 0 -127 32.5t-86 91t-31 135.5t32.5 136.5t88.5 93.5t128 34q134 0 206.5 -99.5t72.5 -282.5q0 -145 -32 -246t-94 -153.5 t-152 -52.5zM331 377q72 0 119 43.5t47 110.5q0 60 -23.5 107.5t-64 75.5t-91.5 28q-73 0 -120 -51t-47 -131q0 -81 50.5 -132t129.5 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 600,
    d: "M300 300q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 600,
    d: "M300 300q-25 0 -42.5 17.5t-17.5 42.5t17.5 42.5t42.5 17.5t42.5 -17.5t17.5 -42.5t-17.5 -42.5t-42.5 -17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt",
    horizAdvX: 0,
    d: "M223 570l64 270h90v-4l-92 -266h-62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A.case",
    horizAdvX: 0,
    d: "M300 858q-37 0 -68.5 18t-50 48.5t-18.5 68.5q0 39 18.5 69.5t50 48t68.5 17.5q38 0 69 -17.5t49.5 -48t18.5 -69.5q0 -38 -18.5 -68.5t-49.5 -48.5t-69 -18zM300 919q30 0 52 21t22 53t-22 53t-52 21t-52 -21t-22 -53t22 -53t52 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328.e",
    horizAdvX: 0,
    d: "M294 -240q-46 0 -68 23.5t-22 66.5q0 53 34.5 99.5t74.5 72.5h50q-42 -40 -62.5 -78t-20.5 -91v-27h110v-66h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.narrow",
    horizAdvX: 0,
    d: "M381 691q-23 0 -38 17t-15 42q0 26 15 42.5t38 16.5t38 -16.5t15 -42.5q0 -25 -15 -42t-38 -17zM219 691q-23 0 -38 17t-15 42q0 26 15 42.5t38 16.5t38 -16.5t15 -42.5q0 -25 -15 -42t-38 -17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304.narrow",
    horizAdvX: 0,
    d: "M176 717v66h248v-66h-248z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\u2026",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\u201E",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "\u201A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: ".",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: ",",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "!",
    u2: "!",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1EF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1E85",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1E83",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u1E81",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u017E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u017C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u017A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u0177",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u0175",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xFF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xFD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "z",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "w",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "!",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u1EF2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0178",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0176",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xDD",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "Y",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1EF2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0178",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0176",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xDD",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "Y",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0161",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u010D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0161",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u010D",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xE4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xE4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "*",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "!",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "seven.lf",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "seven.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "five.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "seven.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "four.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "five.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "two.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "one.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "nine.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "five.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "four.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "zero.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    u2: "2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "nine.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "eight.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "six.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "five.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "four.lf",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "three.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "zero.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "one.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "six.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "two.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "zero.lf",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,J,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hbar,Imacron,Iogonek,Idotaccent,IJ,Nacute,uni0145,Ncaron,Eng",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "T,Tcaron,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "X",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Thorn,Dcaron,Dcroat,Omacron,Ohungarumlaut",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,i,l,igrave,iacute,icircumflex,idieresis,dcroat,imacron,lacute,uni013C,lslash,fi,fl,i.loclTRK",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "T,Tcaron,uni021A",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,germandbls,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,ohungarumlaut",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q,u,ugrave,uacute,ucircumflex,udieresis,dotlessi,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0237",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "T,Tcaron,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,edotaccent,eogonek,ecaron,oe",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Edotaccent,Eogonek,Ecaron,OE",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek",
    g2: "x",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,uni0146,ncaron,eng",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "f,fi,fl,f_f",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "T,Tcaron,uni021A",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "t,tcaron,uni021B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "T,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "T,Tcaron,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Lslash",
    g2: "t,tcaron,uni021B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "T,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni0218",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "hyphen,endash,emdash",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "B,D,E,F,H,I,J,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Edotaccent,Eogonek,Ecaron,Hbar,Imacron,Iogonek,Idotaccent,IJ,uni0136,Lacute,uni013B,Lcaron,Lslash,Nacute,uni0145,Ncaron,Eng,Racute,uni0156,Rcaron",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcaron,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcaron,uni021B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni0219",
    g2: "X",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "T,Tcaron,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,uni0122",
    g2: "hyphen,endash,emdash",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "T,Tcaron,uni021A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "t,tcaron,uni021B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gbreve,gdotaccent,uni0123",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "T,Tcaron,uni021A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "hyphen,endash,emdash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136",
    g2: "t,tcaron,uni021B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "hyphen,endash,emdash",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcaron,uni021A",
    g2: "x",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcaron,uni021A",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "B,D,E,F,H,I,J,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Edotaccent,Eogonek,Ecaron,Hbar,Imacron,Iogonek,Idotaccent,IJ,uni0136,Lacute,uni013B,Lcaron,Lslash,Nacute,uni0145,Ncaron,Eng,Racute,uni0156,Rcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "b,h,i,k,l,germandbls,igrave,iacute,icircumflex,idieresis,thorn,hbar,imacron,ij,uni0137,lacute,uni013C,lcaron,lslash,i.loclTRK",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "S,Sacute,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "f,fi,fl,f_f",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "T,Tcaron,uni021A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,uni0137",
    g2: "hyphen,endash,emdash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "T,Tcaron,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni1E9E",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "colon,semicolon",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright,bracketright,braceright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,wgrave,wacute,wdieresis,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "z,zacute,zdotaccent,zcaron",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni021B",
    g2: "X",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,uni0122,Omacron,Ohungarumlaut,OE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "g,gbreve,gdotaccent,uni0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,edotaccent,eogonek,ecaron,omacron,ohungarumlaut,oe",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni0237",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "s,sacute,scedilla,scaron,uni0219",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "parenright,bracketright,braceright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "hyphen,endash,emdash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "guillemotleft,guilsinglleft",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "guillemotright,guilsinglright",
    k: 90
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.6089085b57a1a33592d2466b42db65b4.svg";
export { ForwardRef as ReactComponent };